import { Box, Menu, styled } from '@mui/material';
import { spaceCadet } from '../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  alignItems: 'center',
  justifyContent: 'center',
  padding: '36px 24px',
  '& > img': {
    width: 300,
    height: 'auto',
  },

  '& > .MuiBox-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    alignItems: 'center',
    justifyContent: 'center',

    '& > .MuiButton-root': {
      textTransform: 'none',
    },
  },
});

export const StyledMenu = styled(Menu)({
  '& .MuiMenuItem-root': {
    fontSize: 14,
    lineHeight: '24px',
    color: spaceCadet[500],
    padding: '4px 8px',

    '& svg': {
      fontSize: 20,
      marginRight: 4,
      color: spaceCadet[500],
    },
  },
});

export default StyledBox;
